import { say } from "../../words.ts";

/**
 * The words harvesting shows (ADR-142 decision 3): the message line for a refusal or a break. Pure: a code in, a
 * sentence out; every sentence is the language files' (`harvest.*`).
 */

const REFUSED = ["tool", "reach", "gone", "full", "busy", "dead", "frozen", "combat"] as const;
const BROKEN = ["moved", "damaged", "combat", "acted", "gone", "full", "tool"] as const;

/**
 * The message line for a refused `harvest`.
 *
 * @param reason The code the server sent.
 * @returns The sentence; a code the page does not word reads as `harvest.refused.unknown`.
 */
export function refusedLine(reason: string): string {
  const known = (REFUSED as readonly string[]).includes(reason) ? (reason as (typeof REFUSED)[number]) : null;
  return known === null ? say("harvest.refused.unknown") : say(`harvest.refused.${known}`);
}

/**
 * The message line for a hold that broke.
 *
 * @param reason The code the server sent.
 * @returns The sentence; a code with no words of its own reads as `harvest.broken.unknown`.
 */
export function brokenLine(reason: string): string {
  const known = (BROKEN as readonly string[]).includes(reason) ? (reason as (typeof BROKEN)[number]) : null;
  return known === null ? say("harvest.broken.unknown") : say(`harvest.broken.${known}`);
}
